/**
 * Generic cursor-based poller.
 *
 * Wraps a paginated fetch function and tracks the cursor between calls.
 * Compatible with `TopicPollingConfig.pollingFn` — just call `poll()`.
 */
export class CursorPoller<T> {
  private cursor: string | null = null;

  constructor(
    private readonly fetchFn: (params: {
      limit: number;
      cursor?: string;
    }) => Promise<{ data: T[]; pagination: { next_cursor: string | null } }>,
    private readonly limit: number = 50,
  ) {}

  async poll(): Promise<T[]> {
    const params: { limit: number; cursor?: string } = { limit: this.limit };
    if (this.cursor) {
      params.cursor = this.cursor;
    }

    const response = await this.fetchFn(params);

    // Advance cursor if server returned one; keep current cursor if null (no new items)
    if (response.pagination.next_cursor !== null) {
      this.cursor = response.pagination.next_cursor;
    }

    return response.data;
  }

  reset(): void {
    this.cursor = null;
  }
}
